import script from "./InspecaoSupervisaoEstabelecimentoCabecalho.vue?vue&type=script&setup=true&lang=js"
export * from "./InspecaoSupervisaoEstabelecimentoCabecalho.vue?vue&type=script&setup=true&lang=js"

import "./InspecaoSupervisaoEstabelecimentoCabecalho.vue?vue&type=style&index=0&id=af1536bc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af1536bc"]])

export default __exports__